<script>
import utils from '@/utils/common';

import CommonDropdown from '../../CommonDropdown.vue';
import BaseCheckbox from '../../BaseCheckbox.vue';

export default {
  name: 'MaterialListFooterBar',
  components: { CommonDropdown, BaseCheckbox },
  props: {
    items: Array,
    itemsChecked: Array,
  },
  data() {
    return {
      staticSelection: false,
      isOpenedMenu: false,
    };
  },
  mounted() {
    document.addEventListener('click', this.closeMenu);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.closeMenu);
  },
  computed: {
    menuItems() {
      return [
        { text: 'Удалить',                icon: 'trash',          action: 'delete',                   mode: null,    }, // eslint-disable-line
      ];//.map(item => ({ ...item, handler: () => this.change(item.action, item.mode) }));
    },

    itemsWord() {
      return utils.pluralWord(this.itemsChecked.length, 'материал', 'материала', 'материалов');
    },

    checkboxValue() {
      if (this.items.length === 0) {
        return false;
      }

      return this.items.length === this.itemsChecked.length;
    },
  },
  methods: {
    async change(action, mode) {
      const resolve = await this.$refs?.actionPopup?.open(action, mode);

      if (resolve) {
        this.$emit('update');
      }
    },

    closeMenu(e) {
      if (this.$refs.actions && !this.$refs.actions.contains(e.target)) {
        this.isOpenedMenu = false;
      }
    },
  },
};
</script>

<template lang="pug">
.b.material-list-footer-bar(:class="{ static: staticSelection }")
  ._selected-value Выбрано:
    span  {{ itemsWord }}
  ._selected-actions(ref="actions")
    Btn._button(:disabled="!itemsChecked.length || !menuItems.length" @click="isOpenedMenu = !isOpenedMenu" round blue) Действия
    CommonDropdown._dropdown(ref="dropdown" :items="menuItems" :isOpened="isOpenedMenu" @click.native="isOpenedMenu = false" dark noTriangle)
  ._checkbox
    BaseCheckbox(:value="checkboxValue" :disabled="items.length <= 0" @input="$emit('toggleAllItems')" label="Все материалы" notColoredLabel)
</template>

<style scoped lang="scss">
.material-list-footer-bar {
  padding: 16px 0;
  display: grid;
  align-items: center;
  color: var(--color-white);
  background-color: #1E3147;
  //border-bottom: 1px solid rgba(223, 232, 255, 1);
  grid-template-columns: 330px 1fr max-content;

  &__selected-actions {
    position: relative;
  }

  &__dropdown {
    bottom: calc(100% + 20px);
    //right: 50%;
  }

  &__selected-value {
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 24px;

    span {
      font-weight: 500;
    }
  }

  @media (max-width: 1000px) {
    grid-template-columns: 200px 1fr max-content;
  }

  @media (max-width: 576px) {
    grid-template-columns: 1fr max-content;
    gap: 20px;
    padding-bottom: 26px;
  }

  @media (max-width: 370px) {
    display: flex;
    flex-direction: column;
    gap: 20px;
    align-items: stretch;
    padding: 14px 0 26px;

    &:before {
      content: '';
      display: block;
      width: 66px;
      height: 4px;
      background: #466E9C;
      align-self: center;
    }

    &__button {
      width: 100%;
    }

    &__selected-value {
      text-align: center;
    }
  }
}
</style>
